export default __webpack_public_path__ + "static/media/Virtual3.44917dbf.webp";